import { useSearchParams } from 'react-router-dom';

export type RecordTab = 'mine' | 'site';

/**
 * 「我的 / 本工地」两个 tab（CR-042）。
 *
 * 客户原话：「根据权限显示按键 拍隐蔽工程，里面的记录也可以根据权限显示记录tabs分类，我的/本工地」。
 * 日报、隐蔽工程、采购三页共用这一套：
 * - 有填写权限 → 有「我的」；有查看权限 → 有「本工地」；两个都有才显示 tab 条；
 * - 默认停在「本工地」（有查看权限时，CR-048 推翻 CR-042 的「默认我的」；没有查看权限就是「我的」）；
 * - 当前 tab 写在 `?tab=` 里：待办页的「查看详情」直接指到「本工地」，
 *   切外壳时 `twinPath` 保留 search，tab 跟着走。
 */
export function useRecordTab({ canMine, canSite }: { canMine: boolean; canSite: boolean }) {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab');
  // CR-048：客户原话「进入后默认显示本工地的tab（如果有权限）」
  const fallback: RecordTab = canSite ? 'site' : 'mine';
  const tab: RecordTab =
    (requested === 'site' && canSite) || (requested === 'mine' && canMine)
      ? requested
      : fallback;

  return {
    tab,
    showTabs: canMine && canSite,
    setTab: (next: RecordTab) => {
      const nextParams = new URLSearchParams(params);
      if (next === fallback) nextParams.delete('tab');
      else nextParams.set('tab', next);
      setParams(nextParams, { replace: true });
    },
  };
}
